











































































import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";
import {
  arrangeTimeList,
  createArrangeTime,
  deleteArrangeTime,
  editArrangeTime,
} from "@/api/classSchedule";
import { Prop, Vue, Component } from "vue-property-decorator";
@Component({
  name: "timeStepSelector",
  components: {
    stepTimeRangeSelector,
  },
})
export default class extends Vue {
  dialogVisible: boolean = false;
  isAdding: boolean = false;
  newRangeStart: string = "12:00";
  newRangeEnd: string = "13:00";
  rangeList: any[] = [];
  page: number = 0;
  init() {
    this.isAdding = false;
    this.newRangeStart = "12:00";
    this.newRangeEnd = "13:00";
    this.rangeList = [];
    this.page = 0;
  }
  loadMore(reload: boolean) {
    arrangeTimeList({
      page: reload ? 1 : this.page + 1,
      page_size: 10,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.page = reload ? 1 : this.page + 1;
        const arr = reload ? [] : [...this.rangeList];
        res.data.list.map((item: any) => {
          arr.push({
            time_id: item.time_id,
            start_time: item.start_time.slice(0, 5),
            end_time: item.end_time.slice(0, 5),
            editing: false,
          });
        });
        this.rangeList = arr;
      }
    });
  }
  handleDialogOpen() {
    this.dialogVisible = true;
  }
  toogleShowAdding() {
    this.isAdding = !this.isAdding;
  }
  saveAdding() {
    const start = this.newRangeStart;
    const end = this.newRangeEnd;
    if (
      Number(this.newRangeStart.replace(/:/g, "")) >=
      Number(this.newRangeEnd.replace(/:/g, ""))
    ) {
      this.$message({
        type: "warning",
        message: "开始时间必须小于结束时间",
      });
      return false;
    }
    createArrangeTime({
      start_time: start + ":00",
      end_time: end + ":00",
    }).then((res: any) => {
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "添加成功!",
        });
        this.newRangeStart = "12:00";
        this.newRangeEnd = "13:00";
        this.loadMore(true);
        this.toogleShowAdding();
      } else {
        this.$message({
          type: "error",
          message: "添加失败!" + res.message,
        });
      }
    });
  }
  showEditing(index: number, id: number) {
    this.rangeList[index].editing = true;
  }
  saveEditing(item: any, index: number) {
    if (
      Number(item.start_time.replace(/:/g, "")) >=
      Number(item.end_time.replace(/:/g, ""))
    ) {
      this.$message({
        type: "warning",
        message: "开始时间必须小于结束时间",
      });
      return false;
    }
    editArrangeTime({
      time_id: item.time_id,
      start_time: item.start_time + ":00",
      end_time: item.end_time + ":00",
    }).then((res: any) => {
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "编辑成功!",
        });
        this.loadMore(true);
        this.rangeList[index].editing = false;
      } else {
        this.$message({
          type: "error",
          message: "编辑失败!" + res.message,
        });
      }
    });
  }
  handleSelect(item: any) {
    this.$emit("update:oriStart", item.start_time);
    this.$emit("update:oriEnd", item.end_time);
    this.$emit("change");
    this.dialogVisible = false;
  }
  showDelete(id: number) {
    deleteArrangeTime({ time_id: id }).then((res: any) => {
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.loadMore(true);
      } else {
        this.$message({
          type: "error",
          message: "删除失败!" + res.message,
        });
      }
    });
  }
}
